/**
 * @generated SignedSource<<587e528a1b29e07fbb18bf9743f84575>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_issueViewLayoutTemplatesItemList_ItemList$data = {
  readonly fieldFragments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId: string;
        readonly " $fragmentSpreads": FragmentRefs<"src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "src_issueViewLayoutTemplatesItemList_ItemList";
};
export type src_issueViewLayoutTemplatesItemList_ItemList$key = {
  readonly " $data"?: src_issueViewLayoutTemplatesItemList_ItemList$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_issueViewLayoutTemplatesItemList_ItemList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayCascadingSelectFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "issueViewRelayGoalsFlag"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "jsmSentimentCustomFieldFlag"
    }
  ],
  "kind": "Fragment",
  "name": "src_issueViewLayoutTemplatesItemList_ItemList",
  "selections": [
    {
      "alias": "fieldFragments",
      "concreteType": "JiraIssueFieldConnection",
      "kind": "LinkedField",
      "name": "fields",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "issueViewRelayCascadingSelectFlag",
                      "variableName": "issueViewRelayCascadingSelectFlag"
                    },
                    {
                      "kind": "Variable",
                      "name": "issueViewRelayGoalsFlag",
                      "variableName": "issueViewRelayGoalsFlag"
                    },
                    {
                      "kind": "Variable",
                      "name": "jsmSentimentCustomFieldFlag",
                      "variableName": "jsmSentimentCustomFieldFlag"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "src_issueViewLayoutTemplatesLayoutItem_LayoutItemInternal"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "1b80cc709ff63d2faf30f659ea9475d6";

export default node;
